import { componentStyle } from '@/styling/util/component-style.ts';

export const floatLabelStyle = componentStyle({
    color: '{ color.textSecondary }',
    focusColor: '{ color.textSecondary }',
    fontWeight: '400',
});
